/* ============================================================
   NZG COOKIE-SPERRE LÖSEN, WENN DAS FENSTER UNSICHTBAR IST
   Erstellt: 2026-09-22

   CCM19 (Pixelopment) sperrt die Seite, bis im Cookie-Fenster eine
   Auswahl getroffen ist: Klasse ccm-blocked auf html und body (kein
   Scrollen) und inert auf allen Kindern von body (kein Klick).
   Blendet eine Erweiterung wie „I still don't care about cookies“ das
   Fenster aus, bleibt die Sperre stehen. Die Seite sieht normal aus,
   aber kein Link reagiert (Kundenmail 21.09.2026, PLAN.md, Bekannte
   Probleme).

   Hier nur: Ist die Seite gesperrt und kein Fenster von CCM19 zu
   sehen, wird die Sperre gelöst. Wer das Fenster sieht, bleibt
   gesperrt wie bisher. Eine Einwilligung entsteht dabei nicht, der
   Besucher surft wie vor jeder Auswahl ohne Tracking (gemessen:
   currentVisitorConsent() überall "no", keine Anfrage an Google).
   Ändert CCM19 seine Klassen, tut das Skript nichts mehr.
   ============================================================ */
(function () {
  'use strict';

  var html = document.documentElement;
  // Fenster, Einstellungen (#ccm-details) und alle weiteren Dialoge von CCM19
  var FENSTER = '#ccm-widget, #ccm-details, .ccm-modal, [id^="ccm-control-panel"]';
  var zeit;

  function gesperrt() {
    return html.classList.contains('ccm-blocked');
  }

  function fensterSichtbar() {
    return Array.prototype.some.call(document.querySelectorAll(FENSTER), function (el) {
      return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
    });
  }

  function loesen() {
    html.classList.remove('ccm-blocked');
    document.body.classList.remove('ccm-blocked');
    document.querySelectorAll('body > [inert]').forEach(function (el) {
      el.inert = false;
    });
  }

  // Zweimal prüfen, eine Sekunde auseinander: Ein Fenster, das CCM19
  // gerade aufbaut, darf nicht als ausgeblendet gelten.
  function pruefen() {
    clearTimeout(zeit);
    if (!gesperrt() || fensterSichtbar()) return;
    zeit = setTimeout(function () {
      if (gesperrt() && !fensterSichtbar()) loesen();
    }, 1000);
  }

  new MutationObserver(pruefen).observe(html, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('load', pruefen);
  [1500, 4000, 8000].forEach(function (ms) {
    setTimeout(pruefen, ms);
  });
  pruefen();
})();
